import {Footer} from 'organization/Event/DashboardConfig/ComponentConfigPanel'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import ComponentConfig, {
  SaveButton,
} from 'organization/Event/DashboardConfig/ComponentConfigPanel'
import React, {useEffect, useState} from 'react'
import {useForm} from 'react-hook-form'
import SizeSection from 'organization/Event/WidgetConfig/ButtonStylesConfig/SizeSection'
import BorderSection from 'organization/Event/WidgetConfig/ButtonStylesConfig/BorderSection'
import styled from 'styled-components'
import Button from 'lib/ui/Button'
import TypographySection from 'organization/Event/WidgetConfig/ButtonStylesConfig/TypographySection'
import {CalendarStyles, Widget} from 'Event/Widget/template'
import {renderCalendar} from 'Event/Widget/script/elements/calendar'
import {spacing} from 'lib/ui/theme'

export default function CalendarStylesConfig(props: {
  styles: CalendarStyles
  onChange: (updatedStyles: CalendarStyles) => void
  widget: Widget
}) {
  const {styles, onChange, widget} = props

  const [showing, setShowing] = useState(false)
  const {control, handleSubmit, watch, formState, reset} = useForm({
    defaultValues: styles || undefined,
  })

  const onClose = () => {
    setShowing(false)
  }

  const saveChanges = (data: CalendarStyles) => {
    onChange(data)
    reset(data)
    onClose()
  }

  const ref = React.useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (ref.current) {
      renderCalendar(
        ref.current,
        {
          ...widget,
          template: {
            ...widget.template,
            calendar: {
              ...widget.template.calendar,
              styles: watch(),
            },
          },
        },
        '',
      )
    }
  }, [widget, ref, watch])

  return (
    <>
      <ConfigureButton variant="outlined" onClick={() => setShowing(true)}>
        {'Button Configuration'}
      </ConfigureButton>

      <PreviewHolder>
        <div ref={ref}></div>
      </PreviewHolder>

      <ComponentConfig
        showing={showing}
        onClose={onClose}
        title={'Button Configuration'}
        onSubmit={handleSubmit(saveChanges)}
        hasChanges={formState.isDirty}
      >
        <StylingPanel>
          <TypographySection
            button={styles}
            control={control}
            storageKey="cf"
            disableColors={true}
          />
          <SizeSection
            button={styles}
            control={control}
            storageKey="cf"
            maxWidth={400}
          />
          <BorderSection button={styles} control={control} storageKey="cf" />
        </StylingPanel>

        <Footer>
          <SaveButton type="submit" />
        </Footer>
      </ComponentConfig>
    </>
  )
}

export const ConfigureButton = styled(Button)`
  color: #6386ef;
  border-color: #6386ef;

  &:hover {
    background-color: #6386ef;
    color: #ffffff;
  }
`

export const PreviewHolder = styled.div`
  display: flex;
  gap: ${spacing[4]};
  justify-content: center;
  width: 100%;
  align-items: center;
  margin-top: 60px;
  border-radius: 4px;
  padding: ${spacing[12]};
  background-color: #ffffff;
  text-align: center;
  border: 1px dashed;
  overflow: hidden;
`
